import axios from 'axios';

// Determine which API URL to use based on the flag
const useProduction = process.env.REACT_APP_USE_PRODUCTION === 'true';
const apiUrl = useProduction
  ? process.env.REACT_APP_PROD_API_URL
  : process.env.REACT_APP_DEV_API_URL;

// The session JWT lives in an HttpOnly cookie set by the server; the browser
// attaches it automatically. No token is ever read from or written to storage.
const API = axios.create({
  baseURL: apiUrl,
  withCredentials: true,
});

export default API;
